import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Ban } from 'lucide-react';
import { buildMarketingUrl } from '@/lib/workspace';

interface ReservedSubdomainPageProps {
  sub: string;
}

export function ReservedSubdomainPage({ sub }: ReservedSubdomainPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <Ban className="h-12 w-12 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl">Not available</CardTitle>
          <CardDescription>
            <code className="text-sm font-mono">{sub}</code>.icrop.net is reserved and not in use.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild>
            <a href={buildMarketingUrl()}>Go to iCrop.net</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
